type RecargaDatosEmpresaHandler = () => void | Promise<void>;

const handlers = new Set<RecargaDatosEmpresaHandler>();

/**
 * Registra un manejador que se ejecuta al guardar datos de empresa en Mis datos
 * (colaboradora, inmobiliaria, documentación…). Devuelve función para desregistrar.
 */
export function registrarRecargaDatosEmpresaMisDatos(handler: RecargaDatosEmpresaHandler): () => void {
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}

/** Recarga userInfo, empresa colaboradora, inmobiliaria, etc. según los manejadores registrados. */
export async function recargarDatosEmpresaMisDatos(): Promise<void> {
  await Promise.all([...handlers].map((handler) => handler()));
}
